import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/ManagingResourcesContent';

export default function ManagingResources() {
  return <DocContent blocks={blocks} />;
}
